import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Box from '../ui/Box';
import moment from 'moment';

import NewSchedule from './NewSchedule';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService';
var ls = LocalStorageService;

export default class ListSchedules extends Component {

  constructor(props) {
    super(props);
    this.state = {
      schedulesList: [],
      allSwitches: [],

      current_offset: 0,
      activePage: 1,
      totalCount: 0,

      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  maxItems = 7;
  scheduleDetails = {};
  schedulesArray = [];

  componentDidMount() {
    this.getHotelDevices();
    this.getSchedulesList(this.state.current_offset);

    window.addEventListener('updateScheduleTable', (e) => {
      if (e.detail && e.detail == true) {
        this.refreshTable();
      }
    });
  }

  onChangePage(e) {
    this.getSchedulesList(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    });
  }

  getHotelDevices() {
    ds.getAllPresentDevices(
      data => {
        this.setState({
          allSwitches: data.switchAppliances,
        });
      },
      err => { }
    );
  }

  getSchedulesList(offset, offset_change = 0) {
    const payload = {
      offset,
      limit: this.maxItems
    };

    ds.postListSchedules(payload,
      data => {
        if (data && data.docs && data.docs.length) {
          data.docs.forEach((itemPresent) => {
            let m = new Date();
            m.setHours(itemPresent.hour);
            m.setMinutes(itemPresent.mins);
            itemPresent.scheduleTime = moment(m.getTime()).format("hh:mm A");
          });
        }
        this.setState({
          schedulesList: data.docs,
          totalCount: data.count
        });

        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, err => { }
    )
  }

  refreshTable(e) {
    this.getSchedulesList(this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0, 1);
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });

    if (refresh) {
      this.refreshTable();
    }

  }

  editSchedule(row, e) {
    const time = new Date().setHours(row.hour, row.mins);
    row.timeObject = time;
    row.allSwitches = this.state.allSwitches;
    this.schedulesArray = [];

    row.actions.forEach((actionPresent) => {
      this.state.allSwitches.forEach((switchPresent) => {
        if (actionPresent.switch_appliance_id._id.toString() == switchPresent._id.toString()) {
          this.scheduleDetails = {
            hotel_room_id: '',
            switch: {
              value: '',
              details: ''
            },
            action: '',
            roomSwitches: []
          };
          this.scheduleDetails.hotel_room_id = switchPresent.hotel_room_id;
          this.scheduleDetails.switch.value = actionPresent.switch_appliance_id.name;
          this.scheduleDetails.switch.details = actionPresent;
          this.scheduleDetails.action = actionPresent.switch_state == 1 ? 'ON' : 'OFF';
          this.schedulesArray.push(this.scheduleDetails);
        }
      });
    });

    if (this.schedulesArray && this.schedulesArray.length) {
      row.scheduleDetails = this.schedulesArray;
    }

    row.scheduleDetails.forEach((detailPresent) => {
      let roomSwitches = [];
      this.state.allSwitches.forEach((switchPresent) => {
        if (
          detailPresent.switch.details.UDid._id.toString() == switchPresent.UDid.toString()
        ) {
          roomSwitches.push({
            label: switchPresent.name,
            value: switchPresent.name
          });
        }
      });
      detailPresent.roomSwitches = roomSwitches;
    });

    this.setState({
      dialog: {
        open: true,
        body: <NewSchedule details={row} unMountMe={this.closeDialog.bind(this)} />,
        actions: []
      }
    });
  }

  deleteSchedule(row, e) {
    this.setState({
      dialog: {
        open: true,
        head: 'Delete',
        body: 'Delete Schedule permanently?',
        actions: [

          <FlatButton
            label="Delete"
            primary
            onClick={() => {
              ds.postDeleteSchedule({ id: row._id },
                data => {
                  let x = this.state.current_offset - this.state.maxItems;
                  this.closeDialog();
                  this.getSchedulesList(x > 0 ? x : 0, 1);
                },
                err => { }
              );
            }}
          />,

          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    })
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)}
    />
    return (
      <div>
        <Box header='Schedules List'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
            autoScrollBodyContent={true}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>

          <Table
            height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            style={{ minWidth: 680 }}
            bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Schedule Name">Name</TableHeaderColumn>
                <TableHeaderColumn tooltip="Schedule Time">Time</TableHeaderColumn>
                <TableHeaderColumn tooltip="Schedule Actions">Actions</TableHeaderColumn>
                <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.schedulesList.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn>{row.scheduleName}</TableRowColumn>
                    <TableRowColumn>{row.scheduleTime}</TableRowColumn>
                    <TableRowColumn>
                      {
                        row.actions && row.actions.length ?
                          row.actions.map((actionPresent, ind) => {
                            return <div>
                              {
                                actionPresent.act_type && actionPresent.act_type == 'switch' ?
                                  actionPresent.switch_appliance_id ?
                                    (actionPresent.switch_appliance_id.name + (actionPresent.hotel_room_id && actionPresent.hotel_room_id.name ? ' in ' + actionPresent.hotel_room_id.name : ''))
                                    : 'NA'
                                  : ''
                              }
                              {
                                actionPresent.act_type == 'switch' ?
                                  actionPresent.switch_state ?
                                    ' - Turn ON'
                                    :
                                    ' - Turn OFF'
                                  : ''
                              }
                              {
                                actionPresent.act_type == "regulate" ?
                                  ` Set FAN Speed to ${row.dimm_value}`
                                  : ''

                              }
                            </div>
                          })
                          : null
                      }
                    </TableRowColumn>

                    <TableRowColumn>
                      <i className="material-icons link-fg"
                        style={{ cursor: 'pointer' }}
                        onClick={this.editSchedule.bind(this, row)}
                      >
                        mode_edit
                      </i>

                      <i className="space"></i>

                      <i className="material-icons warn-fg"
                        style={{ cursor: 'pointer' }}
                        onClick={this.deleteSchedule.bind(this, row)}
                      >
                        delete
                      </i>
                    </TableRowColumn>
                  </TableRow>
                ))
              }
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableRowColumn colSpan="4" style={{ textAlign: 'center' }}></TableRowColumn>
                <TableRowColumn colSpan="3" style={{ textAlign: 'right' }}>{pagination}</TableRowColumn>
              </TableRow>
            </TableFooter>

          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/schedule/ListSchedules.js